import moment from 'moment';
import { getSignsLeftSide, getSignsRightSide } from '@/util/replaceFidaKpi';
//
export function convertApiResponseAllStores(apiResponse) {
  const convertedResponse = {};
  for (const item of apiResponse) {
    if (item.storeCode) {
      convertedResponse[item.storeCode] = {
        storeID: item.id, //parseInt(item.id, 36) % 100, // You can change this calculation as needed
        storeCode: item.storeCode,
        storeName: item.name
      };
    }
  }
   
  return convertedResponse;
}
function getStoreArea(storeCode) {
  const storeList =
    JSON.parse(localStorage.getItem('vuex'))?.user?.storesCodeName || [];
  const found = storeList.find(v => v.storeCode === storeCode);
  return found?.area ? parseFloat(found.area) : 1; // Default to 1 to avoid division by 0
}
function getStoreName(storeCode) {
  const findStoreName = JSON.parse(
    localStorage.getItem('vuex')
  )?.user?.storesCodeName?.find(v => v.storeCode === storeCode);
  return findStoreName?.name
    ? `${storeCode} - ${findStoreName.name}`
    : storeCode;
}
function getCityName(storeCode) {
  const findStoreName = JSON.parse(
    localStorage.getItem('vuex')
  )?.user?.storesCodeName?.find(v => v.storeCode === storeCode);
  return findStoreName.cityId;
}
export function groupByDateWithStores(data, addC = false) {
  return new Promise((resolve) => {
    const grouped = {};

    const lang =
      JSON.parse(localStorage.getItem("vuex") || "{}")?.user?.locale || "en";

    const storesLength =
      localStorage.getItem("storeCodes")?.split(",")?.length || 1;

    const years = new Set(
      data.map((item) =>
        moment(item._id.split("_")[0], "YYYYMMDD").year()
      )
    );
    const hasCrossYear = years.size > 1;
    const nowYear = moment().year();
    const dividFix = ["cn", "cr", "tra", "cnC", "crC", "traC"];

    // ✅ caches
    const storeNameCache = new Map();
    const cityNameCache = new Map();
    const storeAreaCache = new Map();

    const getCachedStoreName = (id) => {
      if (!storeNameCache.has(id)) {
        storeNameCache.set(id, getStoreName(id));
      }
      return storeNameCache.get(id);
    };

    const getCachedCityName = (id) => {
      if (!cityNameCache.has(id)) {
        cityNameCache.set(id, getCityName(id));
      }
      return cityNameCache.get(id);
    };

    const getCachedStoreArea = (code) => {
      if (!storeAreaCache.has(code)) {
        storeAreaCache.set(code, getStoreArea(code));
      }
      return storeAreaCache.get(code);
    };

    const formatDate = (m) => {
      const weekday =
        lang === "ja" ? `(${"日月火水木金土"[m.day()]})` : `(${m.format("ddd")})`;
      const datePart =
        hasCrossYear || m.year() !== nowYear
          ? m.format("YYYY/MM/DD")
          : m.format("MM/DD");
      return `${datePart} ${weekday}`;
    };

    // ✅ Precompute summary once
    const summary = {};
    for (const e of data) {
      const [rawDate, storeId] = e._id.split("_");
      const dateKey = rawDate;
      const dw = parseInt(e.dw || 0, 10);
      if (!summary[dateKey]) summary[dateKey] = { storeCount: 0, dw: 0, dwCount: 0 };
      if (dw > 0) {
        summary[dateKey].dw += dw * 2;
        summary[dateKey].dwCount += 1;
        if (!summary[dateKey][storeId]) summary[dateKey][storeId] = { storeCount: 0 };
        summary[dateKey][storeId].storeCount = dw;
      }
    }

    function getSafeNumber(value) {
      return typeof value === "number" && isFinite(value) && !isNaN(value)
        ? value
        : 0;
    }

    const formatValue = (
      key,
      value,
      rowData = {},
      isC = false,
      storesLength = 1,
      storeArea = 1,
      valueDivid = 1
    ) => {
      if (typeof value !== "number") return value;
      const getParsed = (k) => {
        const raw = rowData[k] ?? rowData[isC ? `${k}C` : k] ?? 0;
        return parseFloat(raw?.toString().replace(/[¥,]/g, "")) || 0;
      };

      let computed;
      switch (key) {
        case "cn":
        case "cnC":
          computed = (getParsed("trn") / getParsed("trf")) * 100;
          break;
        case "cr":
        case "crC":
          computed = (getParsed("trf") / getParsed("pb")) * 100;
          break;
        case "tra":
        case "traC":
          computed = (getParsed("sls") / getParsed("st")) * 100;
          break;
        case "ap":
        case "apC":
          computed = Math.round(getParsed("sls") / getParsed("trn"));
          break;
        case "upt":
        case "uptC":
          computed = (getParsed("is") / getParsed("trn")).toFixed(2);
          break;
        case "rov":
        case "rovC":
          computed = Math.round(getParsed("sls") / getParsed("trf"));
          break;
        case "aip":
        case "aipC":
          computed = Math.round(getParsed("sls") / getParsed("is"));
          break;
        case "sh":
        case "shC":
        case "sl":
        case "slC":
        case "cs":
        case "csC":
        case "se":
        case "seC":
          computed = Math.round(getParsed(key) / storesLength);
          break;
        case "spt":
        case "sptC":
          computed = Math.round(getParsed("sls") / storeArea);
          break;
        case "tpt":
        case "tptC":
          computed = parseFloat((getParsed("trf") / storeArea)?.toFixed(2));
          break;
        case "dw":
        case "dwC": {
          const totalSeconds = value / valueDivid;
          const min = Math.floor(totalSeconds / 60);
          const sec = Math.round(totalSeconds % 60);
          return lang.startsWith("ja")
            ? `${min}分 : ${sec}秒`
            : `${min}min : ${sec}s`;
        }
        default:
          computed = value;
      }

      const baseKey = key.replace(/C$/, "");
      const formatted = dividFix.includes(key)
        ? getSafeNumber(computed)?.toFixed(2).toLocaleString()
        : getSafeNumber(computed)?.toLocaleString();

      return `${getSignsLeftSide(baseKey)}${formatted}${getSignsRightSide(baseKey)}`;
    };

    // ✅ Batch processing
    let i = 0;
    const batchSize = 500;

    function processBatch() {
      const end = Math.min(i + batchSize, data.length);

      for (; i < end; i++) {
        const item = data[i];
        const [rawDate, storeId] = item._id.split("_");
        const dateKey = rawDate;
        const m = moment(rawDate, "YYYYMMDD");
        const displayDate = formatDate(m);
        const storeName = getCachedStoreName(storeId);
        const cityName = getCachedCityName(storeId);
        const keyStore = addC ? "storesC" : "stores";

        if (!grouped[dateKey]) {
          grouped[dateKey] = {
            dateD: dateKey,
            date: displayDate,
            [keyStore]: [],
          };
        }

        const itemCopy = { ...item };
        if (item.dw && summary[dateKey][storeId]) {
          itemCopy.dw = summary[dateKey][storeId]?.storeCount;
        }

        const rowObj = {};
        for (const k in itemCopy) {
          if (k === "_id") continue;
          rowObj[addC ? `${k}C` : k] = formatValue(
            k,
            itemCopy[k],
            itemCopy,
            addC,
            storesLength,
            getCachedStoreArea(storeName?.split(" - ")[0]),
            summary[dateKey]?.dwCount || 1
          );
        }

        const storeData = {
          store: storeName,
          city: cityName,
          ...(!addC && { dateWeather: dateKey }),
          ...rowObj,
        };

        grouped[dateKey][keyStore].push(storeData);

        for (const k in itemCopy) {
          const v = itemCopy[k];
          if (k === "_id" || typeof v !== "number") continue;
          const aggKey = addC ? `${k}C` : k;
          if (aggKey === "dw" || aggKey === "dwC") {
            grouped[dateKey][aggKey] = summary[dateKey]?.dw || 0;
          } else {
            grouped[dateKey][aggKey] = (grouped[dateKey][aggKey] || 0) + v;
          }
        }
      }

      if (i < data.length) {
        setTimeout(processBatch, 0);
      } else {
        // ✅ Final formatting
        for (const dateKey in grouped) {
          const row = grouped[dateKey];
          const storeList = row[addC ? "storesC" : "stores"];
          const totalArea = storeList.reduce(
            (sum, s) => sum + getCachedStoreArea(s.store?.split(" - ")[0]),
            0
          );
          const dwCount = summary[dateKey]?.dwCount || 1;
          for (const key in row) {
            if (
              ["date", "dateD", "stores", "storesC"].includes(key) ||
              typeof row[key] !== "number"
            )
              continue;
            const isC = key.endsWith("C");
            row[key] = formatValue(
              key,
              row[key],
              row,
              isC,
              storesLength,
              totalArea,
              dwCount + storesLength
            );
          }
        }

        resolve(Object.values(grouped));
      }
    }

    processBatch();
  });
}


export function mergeByIndexDynamic(baseArray, compareArray) {
  return baseArray.map((baseItem, index) => {
    const compareItem = compareArray[index];
    if (!compareItem) return { ...baseItem };

    // Avoid Object.entries + filter, directly destructure storesC & date
    const { storesC = [], date, ...restCompare } = compareItem;

    // Merge top-level
    const mergedTop = { ...baseItem, ...restCompare };

    if (baseItem.stores && baseItem.stores.length) {
      // Build store map once
      const compareStoreMap = Object.create(null);
      for (let i = 0; i < storesC.length; i++) {
        compareStoreMap[storesC[i].store] = storesC[i];
      }

      // Merge stores
      mergedTop.stores = baseItem.stores.map(baseStore => {
        const compareStore = compareStoreMap[baseStore.store];
        return compareStore ? { ...baseStore, ...compareStore } : baseStore;
      });
    }

    return mergedTop;
  });
}

export function getWeekdayToday() {
  // Get the current date
  const today = new Date();

  // Array of weekday names
  const weekdays = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ];

  // Get the day index (0-6)
  const dayIndex = today.getDay();

  // Get the weekday name
  return weekdays[dayIndex];
}

export function sumKeysAndRemoveId(data) {
  // Initialize an object to store the sums of each key
  const sums = {};

  // Iterate through each object in the array
  data.forEach(item => {
    // Iterate through each key in the current object
    Object.keys(item).forEach(key => {
      // Skip the _id key
      if (key === '_id') return;

      // Get the value for the current key, default to 0 if it's null or undefined
      const value = item[key] ?? 0;

      // Initialize the sum for the key if it doesn't exist
      if (!sums[key]) {
        sums[key] = 0;
      }

      // Add the value to the corresponding key in sums
      sums[key] += value;
    });
  });

  // Return the result with sums and without _id
  return sums;
}